import { Tier } from '@/lib/points';

export enum AuthProvider {
  Email = 'email',
  Google = 'google',
}

export interface ICNCBrand {
  _id: string;
  name: string;
}

export interface ICNCModel {
  _id: string;
  name: string;
  link?: string;
  cncBrand: string;
  picture?: string;
}

export interface ICNCVariant {
  _id: string;
  name: string;
  cncModel: string;
  cncBrand: string;
}

export interface IOwnedMachine {
  _id: string;
  name: string;
  cncBrand: ICNCBrand;
  cncModel: ICNCModel;
  link?: string;
  createdAt: string;
  updatedAt: string;
}

export interface IUser {
  _id: string;
  username: string;
  firstname: string;
  lastname: string;
  email: string;
  cncBrand: string[];
  cncModel: string[];
  locatedAt: string;
  profilePicture: string;
  isVerified: boolean;
  isUserSignupComplete: boolean;
  authProvider: AuthProvider;
  ownedMachines: IOwnedMachine[];
  isOnefinityOfficial: boolean;
  isTrustedMember?: boolean;
  isAdmin?: boolean;
  isBlocked?: boolean;
  // ponytail: legacy single-link field kept for back-compat reads; superseded by socialLinks
  website?: string;
  socialLinks?: {
    website?: string;
    youtube?: string;
    instagram?: string;
    facebook?: string;
    tiktok?: string;
    x?: string;
  };
  followersCount?: number;
  followingCount?: number;
  fileCount?: number;
  likeCount?: number;
  downloadCount?: number;
  isFollowing?: boolean;
  currentPoints?: number;
  tier?: Tier;
  highestTier?: Tier;
  rewardsTermsAcceptedAt?: string | null;
  privacy?: {
    email: boolean;
    firstname: boolean;
    lastname: boolean;
    links: boolean;
    website?: boolean;
  };
  notificationPreferences?: {
    coinsEarned: boolean;
    newPosts: boolean;
  };
}

export interface LoginRequest {
  email: string;
  password: string;
}
export interface AuthResponse {
  status: string;
}

export interface IUserSignupData {
  profilePicture?: string | File;
  username: string;
  email: string;
  password: string;
  firstname: string;
  lastname: string;
  cncBrand: string[];
  cncModel: string[];
  cncVariant: string[];
  locatedAt: string;
}

export type UserState = {
  isAuthenticated: boolean;
  isVerified: boolean;
  isLoading: boolean;
  user: IUser | null;
};

export type PasswordChangeRequest = {
  currentPassword: string;
  newPassword: string;
};

export type ICompleteUserSignup = {
  username: string;
  firstname: string;
  lastname: string;
  cncBrand: string[];
  cncModel: string[];
  cncVariant: string[];
  locatedAt: string;
  profilePicture?: string | File;
  password: string;
};
